// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__l7WzH","wrapper":"Messages_wrapper__pyWop","button":"Messages_button__Hp44W","list":"Messages_list__Vw24k"};